// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 70 ? "8012d7e2" : chunkId) + "." + {"70":"f2b5902b4bb9027e","271":"b746f7305f0fc1d2","309":"c5f49f80db051cf1","585":"f4a76c29629afe72"}[chunkId] + ".js";
};